<template>
  <FiveStarsRating
    ref="field"
    :value="value"
    :variant="FIVE_STAR_RATING_VARIANTS.small"
    :isDisabled="isDisabled"
    :isInteractive="true"
    :hasAlert="isMessageVisible"
    @update:value="$emit('update:value', $event)"
  >
    <FieldValidator
      ref="fieldValidator"
      slot="below"
      class="star-rating-validator"
      :validations="validations"
      :value="value"
      :isRequired="isRequired"
      :showMessageOn="showMessageOn"
      @isValid="onPropChange('isValid', $event)"
      @isMessageVisible="onPropChange('isMessageVisible', $event)"
      @failedValidation="onPropChange('failedValidation', $event)"
    >
      <FieldValidation
        :isValid="isValid"
        :isMessageVisible="isMessageVisible"
        :showIndicator="false"
        :message="validationMessage"
        :type="validationType"
      />
    </FieldValidator>
  </FiveStarsRating>
</template>

<script>
import formFieldInterfaceMixin from '@/components/_shared/Form/form-field-interface-mixin'
import propsFiveStars from '@/components/_shared/Form/FiveStarsRating/props-five-stars'
import FieldValidator, {
  EVENT_TYPES,
} from '@/components/_shared/Form/Validation/FieldValidator.vue'
import FieldValidation, {
  TYPES as VALIDATION_TYPES,
} from '@/components/_shared/Form/Validation/FieldValidation.vue'
import FiveStarsRating, {
  VARIANTS as FIVE_STAR_RATING_VARIANTS,
} from '@/components/_shared/Form/FiveStarsRating/FiveStarsRating.vue'

export default {
  name: 'FormFiveStarsRating',
  components: {
    FiveStarsRating,
    FieldValidator,
    FieldValidation,
  },
  mixins: [formFieldInterfaceMixin],

  props: { ...propsFiveStars },

  data() {
    return {
      isValid: false,
      isMessageVisible: false,
      failedValidation: null,
      FIVE_STAR_RATING_VARIANTS,
    }
  },

  computed: {
    validationMessage() {
      return this.failedValidation?.message || ''
    },

    validationType() {
      return this.failedValidation?.type || VALIDATION_TYPES.error
    },
  },

  methods: {
    getIsValid() {
      return this.isValid
    },

    getIsMessageVisible() {
      return this.isMessageVisible
    },

    validate() {
      this.$refs.fieldValidator.updateOn(EVENT_TYPES.demand)
    },

    setForceMessage() {
      // not implemented
    },

    onPropChange(name, value) {
      this[name] = value
      this.$emit(name, value)
    },
  },
}
</script>

<style lang="scss" scoped>
.star-rating-validator {
  margin-top: 8px;
  cursor: text;
}
</style>
